var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29715",
    "data-name": "Rectangle 29715",
    width: 91,
    height: 91,
    transform: "translate(663 153)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_754",
    "data-name": "Mask Group 754",
    transform: "translate(-663 -153)",
    clipPath: "url(#warning)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-19T150607.104",
    "data-name": "svgexport-6 - 2022-05-19T150607.104",
    transform: "translate(658.864 148.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26839",
    "data-name": "Path 26839",
    d: "M49.636,4.136a45.5,45.5,0,1,0,45.5,45.5,45.5,45.5,0,0,0-45.5-45.5Zm0,82.727A37.227,37.227,0,1,1,86.864,49.636,37.227,37.227,0,0,1,49.636,86.864Z",
    fill: "#cc1915",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26840",
    "data-name": "Path 26840",
    d: "M49.636,24.818A4.136,4.136,0,0,0,45.5,28.955V57.909a4.136,4.136,0,1,0,8.273,0V28.955A4.136,4.136,0,0,0,49.636,24.818Z",
    fill: "#cc1915"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165",
    "data-name": "Ellipse 3165",
    cx: 4.136,
    cy: 4.136,
    r: 4.136,
    transform: "translate(45.5 66.182)",
    fill: "#cc1915"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.76e15b67a29ca2729c22b7ea15e15bb1.svg";
export { ForwardRef as ReactComponent };